console.log("adquick-sort.js");
var quicksortRunning = false;

// Funktion zum Vertauschen eines Elements mit seinem nächsten Geschwisterelement
function swapWithNextSibling(element) {
    var nextSibling = element.nextElementSibling;
    if (nextSibling) {
        // Elternknoten des Elements erhalten
        var parent = element.parentNode;
        // Element vor dem nächsten Geschwisterelement einfügen
        parent.insertBefore(nextSibling, element);
    } else {
        if(debug) console.log("Das Element hat kein nächstes Geschwisterelement.");
    }
}

function moveElementUp(element, positions) {
    for (let i = 0; i < positions; i++) {
        let previousSibling = element.previousElementSibling;
        if (previousSibling) {
            element.parentNode.insertBefore(element, previousSibling);
        } else {
            break; // Stop if there are no more siblings above
        }
    }
}

 function adquickSort() {
    if (window.innerWidth <= 768) {
        debug = false;
        console.log("adquickSort function started");
        quicksortRunning = true;
        
        // Selektiere alle Elemente mit der Klasse 'adquick-item-homepage'
        const adQuickItems = document.querySelectorAll('.adquick-item-homepage');
        const allItems = document.querySelectorAll('.grid.grid--collection.grid--uniform .grid__item');
        

        let movenext = false;
        let lastBannerIndex = 0;
        allItems.forEach((item,index,allItems) => {
            if(index<allItems.length-1){
                //console.log(index + " / " + allItems.length);
                if(item.classList.contains('adquick-item-homepage') || item.classList.contains('adquick-item')){
                    if(((index + 1) % 2) === 0){
                        
                        //ungerader index, muss verschoben werden
                        if(movenext){
                            if(debug) console.log("verschiebe " + index + " um " + (index-lastBannerIndex) + " nach oben");
                            //nach oben schieben bis zum letzten banner
                            moveElementUp(item, index-lastBannerIndex-1);
                            movenext = false;
                            
                        }
                        else{
                            if(debug) console.log("verschiebe " + index + "nach unten");
                            //eins nach unten verschieben
                            swapWithNextSibling(item);
                            //merke dir den index fürs nächste banner
                            lastBannerIndex = index +1;
                            movenext = true;
                        }
                    }
                    else{
                        //gerader index
                        if(movenext){
                            if(debug) console.log("verschiebe " + index+ " um " + (index-lastBannerIndex) + " nach oben");
                            //nach oben schieben bis zum letzten banner
                            moveElementUp(item, index-lastBannerIndex-1);
                            movenext = false;
                        }
                        else{
                            //ist bereits ander richtigen Stelle
                            if(debug) console.log("verschiebe " + index + " nicht");
                            //merke dir den index fürs nächste banner
                            lastBannerIndex = index;
                            movenext = true;
                        }
                    }
                    
                }
            }
        });
        quicksortRunning = false;
    }
}

//adquickSort();





document.addEventListener('DOMContentLoaded', function() {

      // Suche das Bild im DOM
      const imageElement = document.querySelector(".adquick-item a[href='/pages/sicher-bezahlen'] img");
      
      // Prüfe, ob das Bild existiert
      if (imageElement) {
          // Ändere die src-Eigenschaft
          imageElement.src = "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/Zahlungsmethoden-Pitch-Grafik_2.webp?v=1732298001";
          console.log('Bildquelle erfolgreich geändert.');
      } else {
          console.log('Bild nicht gefunden!');
      }
    
  
    adquickSort();

    // Zielnode für den Observer auswählen
    const targetNode = document.querySelector('.grid--collection');
    // Konfiguriere die Beobachtungsoptionen
    const config = { childList: true, subtree: false };
    // Variable, um zu verfolgen, ob adquickSort bereits ausgeführt wurde
    //let adquickSortExecuted = false;

    // Callback-Funktion, die ausgeführt wird, wenn Mutationen beobachtet werden
    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0 ) {
                console.log('Neue Kindelemente wurden hinzugefügt: ');
                console.log(mutation.addedNodes);
            }
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0 ) {
                // Wenn neue Kindelemente hinzugefügt wurden und adquickSort noch nicht ausgeführt wurde
                observer.disconnect();  // Stoppe den Observer nach der Ausführung
                
                setTimeout(() => {
                    adquickSort();
                    setTimeout(() => {
                        adquickSort();
                    }, 500);
                }, 1000);
                
                
                //adquickSortExecuted = true;  // Markiere, dass adquickSort ausgeführt wurde
                break;  // Beende die Schleife, da wir die Funktion nur einmal ausführen wollen
            }
        }
    };

    // Erstelle eine Instanz von MutationObserver mit der Callback-Funktion
    const observer = new MutationObserver(callback);
    // Beginne die Beobachtung des Zielnodes mit den konfigurierten Optionen
    if (targetNode) {
    observer.observe(targetNode, config);
    } else {
    console.error("Das Element mit der Klasse 'grid--collection' wurde nicht gefunden");
    }
});